import React, { Component } from 'react';
import { message, Modal, Radio } from 'antd';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";

const RadioGroup = Radio.Group;

const Config = {
    export: {
        title: '导出内容',
        url: API_URL.evaluate.exportClinicalQuotationRecord,
    },
    publish: {
        title: '发布内容',
        url: API_URL.evaluate.publishClinicalQuotationRecord,
    },
}

class ExportVisitQuotation extends Component {
    state = {
        visible: false,
        isSimple: '',
        clinicalQuotationRecordId: '',
        config: {},
    }

    show = (clinicalQuotationRecordId, type) => {
        this.setState({
            visible: true,
            clinicalQuotationRecordId,
            config: Config[type],
        });
    }

    hide = () => {
        this.setState({ 
            visible: false, 
            isSimple: '',
        });
    }

    submit = () => {
        const { isSimple, clinicalQuotationRecordId, config } = this.state;
        if (!isSimple) {
            message.warning(`请选择${config.title}！`);
            return;
        }
        const options = {
            method: "POST",
            url: config.url,
            data: {
                clinicalQuotationRecordId,
                isSimple,
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success);
                this.hide();
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, isSimple, config } = this.state;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                width="350px"
            >
                <div>{`请选择${config.title}`}:</div>
                <div style={{padding:'10px 0'}}>
                    <RadioGroup onChange={(e)=>{ this.setState({ isSimple: e.target.value })}} value={isSimple} >
                        <Radio style={{display:'block',margin:'10px 0 10px 80px'}} value={'1'}>{'访视报价（简版）'}</Radio>
                        <Radio style={{display:'block',margin:'10px 0 10px 80px'}} value={'0'}>{'访视报价（详细版）'}</Radio>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

export default ExportVisitQuotation;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/ExportVisitQuotation.js